import FollowerDetails from './FollowerDetails';
import Import from './import';

const followers = {
  title: 'Follower',
  fields: {
    name: 'Nome',
    subscribed: 'Iscritto',
    followed: 'Seguito',
    phone: 'Telefono',
    recent_order: 'Ordine recente',
    total_orders: 'Ordini totali',
    birthday: 'Data di nascita',
    google_review: 'Recensione Google',
    marketing_subscription_source: 'Iscritto da',
    loyalty_points: 'Fedeltà',
  },
  empty_list: 'Nessun cliente',
  yes: 'Sì',
  no: 'No',
  buttons: {
    import: 'Importa',
    export: 'Esporta',
  },
  toasts: {
    failed_to_load_data: 'Caricamento dati non riuscito',
  },
  labels: {
    followed_since_date: 'Dal {{date}}',
  },
};

export default {
  ...followers,
  FollowerDetails,
  Import,
};
